import { IStyles, pxToRem, pxTovW } from '@geneo2-web/shared-ui';

export const styles: IStyles = {
  root: {
    backgroundColor: 'neutral.paleGrey',
    paddingTop: pxToRem(10),
    marginBottom: { xs: pxToRem(10), lg: pxTovW(10) },
    padding: {
      xs: `${pxToRem(20)} ${pxToRem(20)} 0`,
      md: pxToRem(20),
      lg: 0,
    },
  },
  headingImage: {
    width: { xs: pxToRem(60), md: pxToRem(69), lg: pxTovW(105) },
    height: { xs: pxToRem(60), md: pxToRem(69), lg: pxTovW(105) },
    borderRadius: { xs: pxToRem(10), md: pxToRem(10), lg: pxTovW(10) },
    objectFit: 'cover',
  },
  mainContainer: {
    display: 'flex',
    // Tablets stack the groups above the resources, like phones; side by side
    // the resource cards get squeezed to a sliver on an iPad in portrait.
    flexDirection: { xs: 'column', lg: 'row' },
    justifyContent: { lg: 'unset' },
    gap: { xs: pxToRem(40), md: pxToRem(30), lg: pxTovW(270) },
    padding: { lg: `${pxTovW(15)} ${pxTovW(240)}` },
    marginTop: { xs: pxToRem(20), md: pxToRem(16), lg: pxTovW(10) },
  },
  leftPanel: {
    width: { lg: pxTovW(555) },
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(27), md: pxToRem(24), lg: pxTovW(30) },
  },
  rightPanel: {
    height: '100%',
    overflow: 'auto',
    paddingX: { xs: pxToRem(18), md: 0, lg: pxTovW(20) },
    flexBasis: { lg: pxTovW(747) },
  },
  rightPanelHeading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: { xs: pxToRem(24), md: pxToRem(18), lg: pxTovW(20) },
  },
  infoBox: {},
  cardsContainer: {
    paddingTop: { xs: pxToRem(18), lg: pxTovW(20) },
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(20), md: pxToRem(18), lg: pxTovW(20) },
    mb: { xs: pxToRem(100), md: pxToRem(10), lg: pxTovW(10) },
  },
  lessonPlanHeading: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(8), md: pxToRem(10), lg: pxTovW(10) },
    marginTop: { xs: pxToRem(10), md: pxToRem(10), lg: pxTovW(10) },
  },
  item: {
    display: { xs: 'flex', md: 'none' },
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: pxToRem(5),
    '&>div': {
      display: 'flex',
      gap: pxToRem(2),
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
};
